import React from 'react';

// on web we don't need all the animations/gestures/bottom sheets
// so we simply just render the page
export const CircularPager = ({
    renderPage,
}: {
    renderPage: () => React.ReactNode;
    renderHandle: () => React.ReactNode;
}) => {
    return <>{renderPage()}</>;
};
